import React from 'react';
import * as S from './styles';
import { AspectRatioProps } from './types';

/**
 * A component which forces an element to maintain a specific aspect ratio.
 *
 * The aspect ratio can be enforced according to the container's height or width,
 * referred to as the `basis` prop.  The `AspectRatio` component will force its child
 * to fill its parent's `basis` dimension, letting the other dimension scale according
 * to the specified aspect ratio.
 */
const AspectRatio: React.FC<AspectRatioProps> = ({
  basis = 'width',
  children,
  className,
  contentsClassName,
  objectFit = 'cover',
  ratio,
  style,
}) => (
  <S.Root $basis={basis} {...{ className, style }}>
    <S.Contents
      className={contentsClassName}
      $basis={basis}
      $objectFit={objectFit}
      $ratio={ratio}
    >
      {children}
      {basis === 'height' && (
        <S.SVG
          xmlns="http://www.w3.org/2000/svg"
          height={1 / ratio}
          width="1"
        />
      )}
    </S.Contents>
  </S.Root>
);

export default AspectRatio;
